<template>
    <div>
        <h1>Feuchter TV</h1>
    </div>
</template>

<script>
export default {
}
</script>
